var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showing == "html" && _vm.icon
    ? _c(
        "div",
        {
          attrs: {
            id: "code-snippet-html",
            role: "tabpanel",
            "aria-labelledby": "tab-html",
          },
        },
        [
          _c("wa-code-block", {
            attrs: {
              "add-highlighting": "",
              "allow-shadow-copy": "",
              "copy-text": "Copy Code Snippet",
              "custom-copy-icon": "faClone",
              "copy-tracking-event": "icon_html_code_copy_button_click",
              "copy-tracking-params": {
                icon_name: _vm.icon.name,
                icon_style: _vm.styling.style,
                icon_family: _vm.styling.family,
              },
              lang: "markup",
              code: `<i class="${_vm.translatedStyle} fa-${_vm.icon.name}${_vm.translatedAnimation}${_vm.translatedRotation}${_vm.translatedSize}"${_vm.translatedIconStyles}></i>`,
            },
          }),
          _vm._v(" "),
          _c("icon-code-snippet-links", {
            attrs: {
              "has-custom-styling": _vm.hasCustomStyling,
              "selected-style": _vm.styling.style,
              "major-version": _vm.majorVersion,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }